export default __webpack_public_path__ + "static/media/german.48607332.svg";